import OrdenCompraManagementPage from "../pages/OrdenCompraManagementPage";

const routes = [
  {
    name: "OrdenCompraManagementPage",
    path: "/ordenes-compra",
    component: OrdenCompraManagementPage,
    meta: { requiresAuth: true, permission: "COMPRAS_ORDEN_SHOW" },
  },
];

export default routes;
